// extracted by mini-css-extract-plugin
module.exports = {"investment-step__radio-list":"ThirdMiddleStep_investment-step__radio-list__EyMmB","button-container":"ThirdMiddleStep_button-container__mTaFw"};